import { UserProgress } from '../services/progressService';

export interface FolderProgress {
    completed: number;
    total: number;
}

// "/courses/bhagavadGita/children" + "sararthaVarsini" -> "courses/bhagavadGita/children/sararthaVarsini"
export const buildFolderDocPath = (collectionPath: string, docId: string): string =>
    `${collectionPath.replace(/^\/+|\/+$/g, '')}/${docId}`;

// Completed lectures under a folder, compared with the folder's
// completableLectureCount (kept up to date nightly by the
// recomputeCourseLectureCounts Cloud Function). Progress keys are full lecture
// paths, so every lecture at any depth under the folder shares its prefix.
// Returns null when there is nothing to show yet.
export const getFolderProgress = (
    progressMap: Map<string, UserProgress>,
    folderDocPath: string,
    completableLectureCount: number | undefined
): FolderProgress | null => {
    if (!completableLectureCount || completableLectureCount <= 0 || progressMap.size === 0) return null;

    const prefix = `${folderDocPath}/children/`;
    let completed = 0;
    progressMap.forEach((progress, key) => {
        if (progress.completionStatus && key.startsWith(prefix)) completed += 1;
    });

    if (completed === 0) return null;
    // Completions of lectures later removed can outnumber the current count
    return { completed: Math.min(completed, completableLectureCount), total: completableLectureCount };
};
